<template>
  <div class="min-vh-100">
    <CRow class="no-gutters px-3 px-sm-0">
      <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
        <h1 class="mr-sm-4 header-main text-uppercase">CHAT ANALYSIS</h1>
      </b-col>
    </CRow>
    <div>
      <chart></chart>
    </div>
    <div>
      <unknown-keyword></unknown-keyword>
    </div>
  </div>
</template>

<script>
import Chart from "./chart.vue";
import UnknownKeyword from "./unknown-keyword.vue";
export default {
  components: {
    Chart,
    UnknownKeyword,
  },
};
</script>

<style>
</style>